import * as React from "react"
import { useState } from "react"
import { Box, Button } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"
import MergeIcon from "@mui/icons-material/MergeType"
import ScienceIcon from "@mui/icons-material/Science"

import { useAdminBrandActions, useMerge } from "../@hooks"
import generateHexColor from "../@utils"
import KeywordTesterModal from "../KeywordTesterModal"


export default function AdminBrandsTableToolbar() {
    const { handleClickUpdateCreate } = useAdminBrandActions({ brandID: null, color: generateHexColor() })
    const { selectedCount, handleOpenMergeModal } = useMerge()
    const [testerOpen, setTesterOpen] = useState(false)

    return <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Button
            variant="outlined"
            size="small"
            startIcon={<ScienceIcon />}
            onClick={() => setTesterOpen(true)}
        >
            Keywords Tester
        </Button>

        {selectedCount >= 1 && (
            <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<MergeIcon />}
                onClick={handleOpenMergeModal}
            >
                Merge ({selectedCount})
            </Button>
        )}
        <ButtonIconSeeker
            onClick={handleClickUpdateCreate}
            icon="square-plus"
            tooltip="Create a new Brand"
            sx={{ fontSize: "1.25rem" }}
        />

        <KeywordTesterModal isOpen={testerOpen} onClose={() => setTesterOpen(false)} />
    </Box>
}
